import { graphql } from "gql";

const INTERNAL_ADMIN_DISTRIBUTION_GROUP_QUERY = graphql(`
  query InternalAdminDistributionGroup($id: [ID!]!) {
    internalAdminDistributionGroup(id: $id) {
      ...InternalAdminDistributionGroup
    }
  }
`);

export default INTERNAL_ADMIN_DISTRIBUTION_GROUP_QUERY;
